/**
 * @file 模型库页模型列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import ModelBaseItem from './ModelBaseItem';
import {IModelBaseListItem} from '../../type';

interface IProps {
    modelList: IModelBaseListItem[];
}

const ModelBaseList: React.FC<IProps> = props => {
    const modelList = props.modelList;
    return (
        <div className="model-base-list">
            {modelList.map(item => (
                <ModelBaseItem key={item.id} model={item} />
            ))}
        </div>
    );
};

export default ModelBaseList;
